// extracted by mini-css-extract-plugin
export default {"Navbar":"StatusNavbar_Navbar__5MP1B","NavbarList":"StatusNavbar_NavbarList__ReKD+","selected":"StatusNavbar_selected__YSZyq"};